import {Loader, Application, Sprite, BLEND_MODES, Filter, Container, Rectangle} from 'pixi.js';

class HeroCyber60 {
    static instance = null;

    static create(el) {
        if(!HeroCyber60.instance) {
            HeroCyber60.instance = new HeroCyber60(el);
        }
        return HeroCyber60.instance;
    }

    static destroy() {
        if(HeroCyber60.instance) {
            HeroCyber60.instance.beforeDestroy();
            HeroCyber60.instance = null;
        }
    }

    constructor(el) {
        this.el = el;
        this.setSizes();
        this.initScene();
        this.loadImages();
    }

    loadImages() {
        this.loader = new Loader();
        this.loader.add('shapeOrange', `${window.theme_assets_url}/images/cyber-60/cyber60_gradient-1.png`);
        this.loader.add('shapeBlue', `${window.theme_assets_url}/images/cyber-60/cyber60_gradient-2.png`);
        // this.loader.add('blur', `${window.theme_assets_url}/images/cyber-60/blur.frag`);
        this.loader.add('turbulence', `${window.theme_assets_url}/images/cyber-60/turbulence.frag`);

        this.loader.load((loader, resources) => {
            this.initSprites(resources);
        });
    }

    initSprites(resources) {
        this.el.parentElement.classList.add('loaded');
        this.shapeOrange = new Sprite(resources.shapeOrange.texture);
        this.shapeBlue = new Sprite(resources.shapeBlue.texture);

        this.shapeBlue.anchor.set(.5, .5);
        this.shapeOrange.anchor.set(.5, .5);

        const blueAspectRatio = this.shapeBlue.texture.orig.width / this.shapeBlue.texture.orig.height;
        this.shapeBlue.height = this.elHeight * 1.2;
        this.shapeBlue.width = this.shapeBlue.height * blueAspectRatio;

        const orangeAspectRatio = this.shapeOrange.texture.orig.width / this.shapeOrange.texture.orig.height;
        this.shapeOrange.height = this.elHeight * 1.2;
        this.shapeOrange.width = this.shapeOrange.height * orangeAspectRatio;

        this.shapeBlue.x = this.elWidth / 2;
        this.shapeBlue.y = this.elHeight / 2;

        this.shapeOrange.x = this.elWidth / 2;
        this.shapeOrange.y = this.elHeight / 2;

        this.shapeBlueScale = this.shapeBlue.scale.x;
        this.shapeOrangeScale = this.shapeOrange.scale.x;

        const turbulenceShader = resources.turbulence.data;
        // const blurShader = resources.blur.data;
        this.uniformTimeAmount = 0;
        this.uniformTimeSize = 0;

        this.speedAmount = 0.01;
        this.speedSize = 0.02;

        this.filterParams = {
            amount: 0.0,
            complexity: 3,
            size: 0.0,
            time: 0.0,
            offsetX: this.elWidth / 2,
            offsetY: this.elHeight / 2,
            offset: [this.elWidth / 2, this.elHeight / 2],
        }

        // this.filterBlurParams = {
        //     blur: 0
        // }

        // this.filterBlur = new Filter(null, blurShader, this.filterBlurParams);

        this.turbulenceFilter = new Filter(null, turbulenceShader, this.filterParams);
        this.turbulenceFilter.autoFit = false;

        this.filterContainer = new Container();
        this.filterContainer.position.set(0, 0);
        this.filterContainer.addChild(this.shapeOrange);
        this.filterContainer.addChild(this.shapeBlue);
        this.filterContainer.filters = [this.turbulenceFilter];

        this.shapeBlue.blendMode = BLEND_MODES.SCREEN;
        this.app.stage.addChild(this.filterContainer);

        const extraWidth = this.elWidth * 0.15;
        const extraHeight = this.elHeight * 0.15;

        this.filterContainer.filterArea = new Rectangle(
            -extraWidth, -extraHeight,
            this.elWidth + extraWidth * 2, this.elHeight + extraHeight * 2
        );

        this.scaleTimeBlue = 0;
        this.scaleTimeOrange = 0;
        this.time = 0;
        this.blur = -1;
        this.isAnimated = true;
        this.app.start();

        this.app.ticker.add((delta) => {
            this.update(delta);
        });
    }

    update(delta) {
        this.shapeBlue.rotation += 0.01;
        this.shapeOrange.rotation -= 0.01;

        this.scaleTimeBlue += delta * 0.005;
        const scaleBlue = 1.2 + 0.3 * Math.sin(this.scaleTimeBlue) * this.shapeBlueScale;
        this.shapeBlue.scale.set(scaleBlue);

        this.scaleTimeOrange += delta * 0.006;
        const scaleOrange = 1 + 0.25 * Math.sin(this.scaleTimeOrange) * this.shapeOrangeScale;
        this.shapeOrange.scale.set(scaleOrange);

        this.uniformTimeAmount += delta * this.speedAmount;
        this.uniformTimeSize += delta * this.speedSize;

        this.time += delta * 0.001;

        this.turbulenceFilter.uniforms.amount = 0.12 * (Math.sin(this.uniformTimeAmount) * 0.5 + 0.5);
        this.turbulenceFilter.uniforms.size = (Math.sin(this.uniformTimeSize) * 0.5 + 0.5);
        this.turbulenceFilter.uniforms.time = Math.sin(this.time);

        // this.blur += delta * 0.01;

        // if(this.blur > 3) {
        //     this.blur = 3;
        // }
        // this.turbulenceFilter.uniforms.blur = this.blur;
    }

    initScene() {
        this.app = new Application({
            width: this.elWidth,
            height: this.elHeight,
            backgroundColor: 0x000000,
            resolution: 1,
            autoResize: true,
            antialias: true,
        });

        this.el.appendChild(this.app.view);
        this.initMonitorIfInView();
    }

    setSizes() {
        this.elWidth = this.el.offsetWidth;
        this.elHeight = this.el.offsetHeight;
    }

    initMonitorIfInView() {
        // detect class .in-view locomotive changes to check if element is in viewport
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if(mutation.target !== this.el) return;
                if (mutation.attributeName === "class") {
                    this.isAnimated = mutation.target.classList.contains("is-inview");
                    if(this.isAnimated) {
                        this.app.start();
                    } else {
                        this.app.stop();
                    }
                }
            });
        });

        observer.observe(this.el, {
            attributes: true,
        });

    }

    beforeDestroy() {
        if(this.shapeBlue) {
            this.shapeBlue.destroy(true);
            this.shapeBlue = null;
        }

        if(this.shapeOrange) {
            this.shapeOrange.destroy(true);
            this.shapeOrange = null;
        }

        if(this.turbulenceFilter) {
            this.turbulenceFilter.destroy(true);
            this.turbulenceFilter = null;
        }

        if(this.filterContainer) {
            this.filterContainer.destroy(true);
            this.filterContainer = null;
        }

        if(this.loader) {
            this.loader.destroy(true);
            this.loader = null;
        }

        if(this.app) {
            this.app.destroy(true);
            this.app = null;
        }
    }
}

export default HeroCyber60;
